interface RatingStarsProps {
  value: number;
  max?: number;
  size?: string;
}

export default function RatingStars({ value, max = 5, size = "text-sm" }: RatingStarsProps) {
  const rounded = Math.round(value);
  return (
    <span className={`inline-flex items-center gap-0.5 ${size} text-primary-500`} aria-label={`评分 ${value} 分`}>
      {Array.from({ length: max }).map((_, i) => (
        <i key={i} className={i < rounded ? "ri-star-fill" : "ri-star-line opacity-40"} />
      ))}
    </span>
  );
}